import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Homepage slider', defaultMessage: 'Homepage slider' },
  slides: { id: 'Slides', defaultMessage: 'Slides' },
  image: { id: 'Image', defaultMessage: 'Image' },
  slideTitle: { id: 'Title', defaultMessage: 'Title' },
  description: { id: 'Subtitle', defaultMessage: 'Subtitle' },
  text_boto: { id: 'Button text', defaultMessage: 'Button text' },
  enllac: { id: 'Link', defaultMessage: 'Link' },
});

const SlideSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.slides),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image', 'title', 'description', 'text_boto', 'enllac'],
    },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['imatge_slider_principal'],
      initialPath: '/home-slider-images',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    title: {
      title: intl.formatMessage(messages.slideTitle),
      widget: 'textarea',
    },
    description: {
      title: intl.formatMessage(messages.description),
      widget: 'textarea',
    },
    text_boto: { title: intl.formatMessage(messages.text_boto) },
    enllac: { title: intl.formatMessage(messages.enllac), widget: 'url' },
  },
  required: ['image'],
});

export const HomepageSliderSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['slides'] }],
  properties: {
    slides: {
      title: intl.formatMessage(messages.slides),
      widget: 'object_list',
      schema: SlideSchema({ intl }),
    },
  },
  required: [],
});
